import React from 'react';

import { SessionContextProvider } from './SessionContext';
import { StaticPropsContextProvider } from './StaticPropsContext';
import { SearchResultContextProvider } from './SearchResultContext';
import { QueryParameterContextProvider } from './QueryParameterContext';
import { ApplicationsPageInitialProps } from '../data/useApplicationsPageProps';
import { SchoolCustomizationProvider } from '~/context/SchoolCustomizationsProvider';
import { SchoolCustomizations } from '~/data/useSchoolCustomizations';

interface SearchContextProvider {
  children: React.ReactNode;
  initialProps: ApplicationsPageInitialProps;
  schoolCustomizations: SchoolCustomizations;
}
export function ApplicationContextProvider(props: SearchContextProvider) {
  return (
    <SessionContextProvider>
      <SchoolCustomizationProvider schoolCustomizations={props.schoolCustomizations}>
        <StaticPropsContextProvider initialProps={props.initialProps}>
          <QueryParameterContextProvider>
            <SearchResultContextProvider>{props.children}</SearchResultContextProvider>
          </QueryParameterContextProvider>
        </StaticPropsContextProvider>
      </SchoolCustomizationProvider>
    </SessionContextProvider>
  );
}
